import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/page/MangoLanding/Index.vue"),
    meta: {
      title: "ManGoTalk 망고톡 ㅣ 내게 꼭 맞춘 1:1영어회화",
      metaInfo: [
        {
          name: "title",
          content: "ManGoTalk 망고톡 ㅣ 내게 꼭 맞춘 1:1영어회화",
        },
        {
          name: "description",
          content:
            "진짜 문제는 회화! 무조건 뱉어야 느는 영어, 원어민 튜터와 맘껏 톡하자! 철저한 검증으로 엄선된 교육 전문 원어민 튜터와 만족할 때까지 진짜 대화를 즐기세요",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:title",
          name: "og:title",
          content: "ManGoTalk 망고톡 ㅣ 내게 꼭 맞춘 1:1영어회화",
        },
        {
          property: "og:description",
          content:
            "진짜 문제는 회화! 무조건 뱉어야 느는 영어, 원어민 튜터와 맘껏 톡하자! 철저한 검증으로 엄선된 교육 전문 원어민 튜터와 만족할 때까지 진짜 대화를 즐기세요",
        },
        {
          property: "og:url",
          content: "https://www.mangotalk.co.kr/ ",
        },
        {
          property: "og:image",
          content: "https://www.mangotalk.co.kr/img/logo.60d42e5e.png",
        },
      ],
    },
  },
  {
    path: "/Privacy",
    component: () => import("@/page/MangoLanding/Privacy.vue"),
  },
  {
    path: "/Terms",
    component: () => import("@/page/MangoLanding/Terms.vue"),
  },
];

const mangolanding = new VueRouter({
  mode: "history",
  routes,
});

mangolanding.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotGlobal" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default mangolanding;
